import { Column } from '@/presentation/components/table';
import { Campaign } from '@/domain/types/campaigns';

export const columns: Column<Campaign>[] = [
  { header: 'Nombre', accessor: 'name' },
  { header: 'Hashtag', accessor: 'hashtag' },
  {
    header: 'Instrucciones',
    accessor: 'instructions',
    render: (value, row) => {
      const text = (value as string) || (row as any).description || '';
      return text ? (
        <span title={text} className="line-clamp-2 max-w-[200px] block">
          {text}
        </span>
      ) : (
        <span className="text-gray-400 italic text-xs">Sin instrucciones</span>
      );
    },
  },
  {
    header: 'Estado',
    accessor: 'isActive',
    render: (value) =>
      value ? (
        <span className="inline-block rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-700">
          Activa
        </span>
      ) : (
        <span className="inline-block rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-500">
          Inactiva
        </span>
      ),
  },
];
